import {Injectable} from "@angular/core";
import {
  BookingPricing,
  GridSpacePricingTimePeriod,
  perPricingPeriod,
  SpacePricingRateCategory
} from "@features/leasing/lease-bookings/bookings.model";
import {LeaseGridSpaceGroup, LeaseSummary, OccupiedSpace, RentalPricingOption} from "./leasing.model";
import {HttpClient, HttpParams} from "@angular/common/http";
import {environment} from "@env/environment";
import {Observable} from "rxjs";
import {OfferingSpacesInterface} from '../spaces/model/offering-spaces.interface';
import {GenericService} from "@ui-kit/framework/common/generic.service";

@Injectable({
  providedIn: 'root'
})
export class LeasingService extends GenericService<LeaseSummary> {
  constructor(http: HttpClient) {
    super(http, environment.apiLeaseHost + `/console/offering/district/leasing`);
  }

  getDistrictSpaces(spaceNames: string | null): Observable<OfferingSpacesInterface[]> {
    let requestParams = new HttpParams();
    if (spaceNames) {
      requestParams = requestParams.append('spaceCodes', spaceNames);
    }
    return this.http.get<OfferingSpacesInterface[]>(this.getBaseUrl + `/lease-planning/grid-spaces`, {params: requestParams});
  }

  getLeaseOccupancy(searchTerm: string | null, startDate: string, endDate: string, status: string | null) {
    let requestParams = new HttpParams()
      .set('leaseStartDate', startDate)
      .set('leaseEndDate', endDate);

    if (searchTerm) {
      requestParams = requestParams.append('spaceName', searchTerm);
    }

    if (status) {
      requestParams = requestParams.append('leaseStatus', status);
    }
    return this.http.get<OccupiedSpace[]>(this.getBaseUrl + `/lease-planning/vacancy`, { params: requestParams });
  }

  savePlannedLeaseSpaceGroup(group: LeaseGridSpaceGroup) {
    return this.http.post<LeaseGridSpaceGroup>(this.getBaseUrl + `/lease-planning/planned`, group);
  }

  abandonAllLeasesInGroup(groupId: string) {
    return this.http.delete<void>(this.getBaseUrl + `/lease-planning/planned/${groupId}`);
  }

  get getBaseUrl() {
    return environment.apiLeaseHost + '/console/offering/district/leasing'
  }

  getRentalType(typeCode: RentalPricingOption | null, bookingPricing: BookingPricing | null): string {
    if (typeCode === RentalPricingOption.TURNOVER_PERCENTAGE) return 'Percentage rental';
    if (typeCode === RentalPricingOption.PRICING_MODEL) return 'Fixed per m²';
    if (typeCode === RentalPricingOption.FIXED_PER_SQM_PER_MONTH) return 'Fixed per m²';
    if (typeCode === RentalPricingOption.FIXED_PER_MONTH) return 'Fixed per month';
    if (typeCode === RentalPricingOption.FIXED_FOR_PERIOD) return 'Fixed for period';
    if (typeCode === RentalPricingOption.FIXED_COMPLEX && bookingPricing) {
      const period = Object.values(GridSpacePricingTimePeriod)
        .find(key => perPricingPeriod[key].patternType.includes(bookingPricing!.patternType));
      const perSqm = bookingPricing.spacePricingRateCategory! == SpacePricingRateCategory.PER_SQM;
      if (period && perSqm) return `Fixed per ${perPricingPeriod[period!].period} per m²`;
      if (period) return `Fixed per ${perPricingPeriod[period!].period}`;
    }
    return '-';
  }
}
